export default {
  methods: {
    /**
     * Subscribe to an ActionCable channel.
     *
     * @param {String} channelName
     * @param {Object} [options={}]  extra parameters for subscription
     * @param {Object} callbacks
     *   • initialized()       — called on WebSocket initialized.
     *   • rejected()          — called on WebSocket rejected.
     *   • connected()         — called on WebSocket connected.
     *   • disconnected()      — called on WebSocket disconnected.
     *   • received(data)      — called when a new message arrives.
     */
    subscribeToChannel(channel, callbacks = {}) {
      if (!this.$cable?.subscriptions?.subscriptions) {
        return
      }

      const ident = JSON.stringify(channel)

      if (this.$cable.subscriptions.subscriptions.find((subscription) => subscription.identifier === ident)) {
        return
      }

      const { initialized, connected, disconnected, rejected, received } = callbacks

      this.$cable.subscriptions.create(channel, {
        initialized: () => {
          initialized?.()
        },
        connected: () => {
          connected?.()
        },
        disconnected: () => {
          disconnected?.()
        },
        received: (data) => {
          received?.(data)
        },
        rejected: () => {
          rejected?.()
        },
      })
    },
    /**
     * Unsubscribe from a specific channel.
     *
     * @param {String} channelName
     */
    unsubscribeFromChannel(ident) {
      if (!this.$cable?.subscriptions?.subscriptions) {
        return
      }

      const sub = this.$cable.subscriptions.subscriptions.find((subscription) => subscription.identifier === ident)
      if (sub) {
        this.$cable.subscriptions.remove(sub)
      }
    },

    /**
     * Unsubscribe from all channels.
     */
    unsubscribeFromAllChannels() {
      if (!this.$cable?.subscriptions?.subscriptions) {
        return
      }

      this.$cable.subscriptions.subscriptions.forEach((sub) => {
        this.unsubscribeFromChannel(sub.identifier)
      })
    },

    beforeDestroy() {
      // Clean up all subscriptions on component destroy
      this.unsubscribeFromAllChannels()
    },
  },
}
